import * as opt from "lib/opt";
import { AiSearchRequest, AiSearchFeedbackRequest } from "models/dto/searchApi";
import {
	AiSearchApiClient,
	GetAiSearchApiInstance,
} from "./apiClient/AiSearchApiClient";
import * as searchApi from "./modules/aiSearch";
import { Store } from "store";

let aiSearchApiWrapperInstance: Opt<AiSearchApiWrapper> = opt.None();

export class AiSearchApiWrapper {
	private client: AiSearchApiClient;

	constructor(store: Store) {
		this.client = GetAiSearchApiInstance(store);
	}

	static GetInstance(store: Store): AiSearchApiWrapper {
		if (aiSearchApiWrapperInstance.IsNone()) {
			aiSearchApiWrapperInstance = opt.Some(new AiSearchApiWrapper(store));
		}
		return aiSearchApiWrapperInstance.Expect(
			"AiSearchApiWrapper instance not found"
		);
	}

	// API Methods
	SearchQuery = (request: AiSearchRequest) =>
		searchApi.AiSearchQuery(this.client, request);

	SendFeedback = (feedback: AiSearchFeedbackRequest) =>
		searchApi.AiSearchFeedback(this.client, feedback);
}
